import { render } from "./GameTipsPage.vue?vue&type=template&id=3780b6a8&scoped=true"
import script from "./GameTipsPage.vue?vue&type=script&lang=js"
export * from "./GameTipsPage.vue?vue&type=script&lang=js"

import "./GameTipsPage.vue?vue&type=style&index=0&id=3780b6a8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3780b6a8"]])

export default __exports__